// src/pages/directions/Directions.js
import React from "react";
import SidebarLayout from "../../components/sidebarLayout";
import Footer from "../../components/footer";
import NavigationBar from "../../components/navbar";
import menuData from "../../data/menuData"; // 메뉴 데이터 가져오기
import { Row, Col } from "react-bootstrap";
import { GoogleMap, LoadScript, MarkerF } from "@react-google-maps/api";

export default function Directions() {
  const directionsMenu = menuData.find((menu) => menu.title === "포럼소개");

  const googleMapsApiKey = process.env.REACT_APP_GOOGLE_MAPS_API_KEY;
  const mapContainerStyle = {
    width: "100%",
    height: "450px",
  };
  const center = {
    lat: 37.5596113961056, // 위도
    lng: 126.837242277605, // 경도
  };

  return (
    <div>
      <SidebarLayout menu={directionsMenu}>
        <Row className="align-items-center">
          {/* 지도 섹션 */}
          <Col md={12} className="text-center mb-4">
            <LoadScript googleMapsApiKey={googleMapsApiKey}>
              <GoogleMap
                mapContainerStyle={mapContainerStyle}
                center={center}
                zoom={15} // 줌 레벨
              >
                <MarkerF
                  position={center}
                  icon={
                    "https://developers.google.com/maps/documentation/javascript/examples/full/images/beachflag.png"
                  }
                />
              </GoogleMap>
            </LoadScript>
          </Col>

          {/* 주소 및 교통편 정보 */}
          <Col md={12}>
            <h5>주소</h5>
            <p>
              서울특별시 강서구 공항대로 269-15, 3층 315-A4호 (마곡동,
              마곡힐스테이트에코마곡)
            </p>

            <h5>대중교통 이용 시</h5>
            <p>5호선 발산역에서 도보 5분</p>

            <h5>문의</h5>
            <p>info@tourismkorea.or.kr</p>
          </Col>
        </Row>
      </SidebarLayout>
    </div>
  );
}
